import { render, staticRenderFns } from "./autopick-setup.vue?vue&type=template&id=6c6c44e3&scoped=true&"
import script from "./autopick-setup.ts?vue&type=script&lang=ts&"
export * from "./autopick-setup.ts?vue&type=script&lang=ts&"
import style0 from "./autopick-setup.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./autopick-setup.vue?vue&type=style&index=1&id=6c6c44e3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6c44e3",
  null
  
)

export default component.exports